<div class="form-check">
    <ng-content select=".check"></ng-content>
    <ng-content select=".label"></ng-content>
</div>
